//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/build/client.js";
import Sortable from "sortablejs";

import { RequestBody, ResponseBodySchema } from "../../../../api/routes/v6/profile-showcase-configuration/update.schemas.js";

//
// Component
//

export function initialiseShowcaseForm(showcaseForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(showcaseForm, "apiUrl");

	const groupsContainer = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, ".groups-container");

	new Sortable(groupsContainer,
		{
			animation: 150,
			handle: ".handle",
		});

	initialiseForm(showcaseForm,
		async () =>
		{
			//
			// About Showcase
			//

			const aboutShowcaseGroup = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, `.group[data-internal-name="about"]`);

			const aboutShowcaseEnabledInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(aboutShowcaseGroup, `input[name="enabled"]`);

			const aboutShowcaseEnabled = aboutShowcaseEnabledInput.checked;

			const aboutShowcaseSortOrder = Array.from(groupsContainer.children).indexOf(aboutShowcaseGroup);

			//
			// Badges Showcase
			//

			const badgesShowcaseGroup = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, `.group[data-internal-name="badges"]`);

			const badgesShowcaseEnabledInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(badgesShowcaseGroup, `input[name="enabled"]`);

			const badgesShowcaseEnabled = badgesShowcaseEnabledInput.checked;

			const badgesShowcaseSortOrder = Array.from(groupsContainer.children).indexOf(badgesShowcaseGroup);

			//
			// Forum Topics Showcase
			//

			const forumTopicsShowcaseGroup = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, `.group[data-internal-name="forumTopics"]`);

			const forumTopicsShowcaseEnabledInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(forumTopicsShowcaseGroup, `input[name="enabled"]`);

			const forumTopicsShowcaseEnabled = forumTopicsShowcaseEnabledInput.checked;

			const forumTopicsShowcaseSortOrder = Array.from(groupsContainer.children).indexOf(forumTopicsShowcaseGroup);

			//
			// Forum Topic Replies Showcase
			//

			const forumTopicRepliesShowcaseGroup = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, `.group[data-internal-name="forumTopicReplies"]`);

			const forumTopicRepliesShowcaseEnabledInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(forumTopicRepliesShowcaseGroup, `input[name="enabled"]`);

			const forumTopicRepliesShowcaseEnabled = forumTopicRepliesShowcaseEnabledInput.checked;

			const forumTopicRepliesShowcaseSortOrder = Array.from(groupsContainer.children).indexOf(forumTopicRepliesShowcaseGroup);

			//
			// Releases Showcase
			//

			const releasesShowcaseGroup = BrowserUtilities.ElementClientLib.getElementOrThrow(showcaseForm, `.group[data-internal-name="releases"]`);

			const releasesShowcaseEnabledInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(releasesShowcaseGroup, `input[name="enabled"]`);

			const releasesShowcaseEnabled = releasesShowcaseEnabledInput.checked;

			const releasesShowcaseSortOrder = Array.from(groupsContainer.children).indexOf(releasesShowcaseGroup);

			const releasesShowcaseReleaseCountInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(releasesShowcaseGroup, `select[name="count"]`);

			const releasesShowcaseReleaseCount = parseInt(releasesShowcaseReleaseCountInput.value);

			const releasesShowcaseReleaseSortModeInput = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(releasesShowcaseGroup, `select[name="sortMode"]`);

			const releasesShowcaseReleaseSortMode = parseInt(releasesShowcaseReleaseSortModeInput.value);

			//
			// Submit
			//

			const requestBody: RequestBody =
			{
				aboutShowcaseEnabled,
				aboutShowcaseSortOrder,

				badgesShowcaseEnabled,
				badgesShowcaseSortOrder,

				forumTopicsShowcaseEnabled,
				forumTopicsShowcaseSortOrder,

				forumTopicRepliesShowcaseEnabled,
				forumTopicRepliesShowcaseSortOrder,

				releasesShowcaseEnabled,
				releasesShowcaseSortOrder,
				releasesShowcaseReleaseCount,
				releasesShowcaseReleaseSortMode,
			};

			const response = await fetch(apiUrl + "/v6/profile-showcase-configuration/update",
				{
					credentials: "include",
					method: "POST",
					headers:
					{
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestBody),
				});

			const responseBody = ResponseBodySchema.parse(await response.json());

			if (!responseBody.success)
			{
				return {
					restoreInputs: true,
					notices: responseBody.errors.map((error) => ({ type: "warning", message: error.message })),
				};
			}

			return {
				restoreInputs: true,
				notices:
				[
					{ type: "success", message: "Your profile showcase settings have been saved." },
				],
			};
		});
	
	showcaseForm.classList.add("initialised");
}

export function initialiseShowcaseForms()
{
	const showcaseForms = document.querySelectorAll<HTMLFormElement>(".component-showcase-form:not(.initialised)");

	console.log("[ShowcaseForm] Initialising " + showcaseForms.length + " instances...");

	for (const showcaseForm of showcaseForms)
	{
		try
		{
			initialiseShowcaseForm(showcaseForm);
		}
		catch (error)
		{
			console.error("[ShowcaseForm] Error initialising:", showcaseForm, error);
		}
	}
}